import { Outlet } from "react-router-dom";

import AppWrapper from "../../../../components/cm/AppWrapper";
import SideBarMain from "../../../../components/cm/SideBarMain";

export default () => {  
  return (
    <AppWrapper.WithSidebar sidebar={<SideBarMain />}>
      <div className="flex flex-col flex-1 mt-6 overflow-y-auto bg-white rounded-b-[15px] rounded-t-lg transparent xl:mr-6">
        <Outlet />
      </div>
    </AppWrapper.WithSidebar>
  );
};
